module.exports = __webpack_public_path__ + "assets/img/car03.a4720496.jpg";